/*
 *
 * ReportAdmin actions
 *
 */

import {
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_FAILED,
  GET_MEASURE_TOTAL_WATCHER,
  GET_MEASURE_TOTAL_SUCCESS,
  GET_MEASURE_TOTAL_FAILED,
  GET_MEASURE_GENERAL_FAILED,
  GET_MEASURE_GENERAL_SUCCESS,
  GET_MEASURE_GENERAL_WATCHER,
  SAVE_CONFIG_BENCHMARK_WATCHER,
  SAVE_CONFIG_BENCHMARK_SUCCESS,
  SAVE_CONFIG_BENCHMARK_FAILED,
} from "./constants"

export function getStatusWatcher(payload) {
  return {
    type: GET_STATUS_WATCHER,
    payload,
  }
}

export function getStatusSuccess(payload) {
  return {
    type: GET_STATUS_SUCCESS,
    payload,
  }
}

export function getStatusFailed() {
  return { type: GET_STATUS_FAILED }
}

export function getMeasureColorRangeWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getMeasureColorRangeSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}

export function getMeasureColorRangeFailed(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_FAILED,
    payload,
  }
}

export function getMeasureGeneralWatcher(payload) {
  return {
    type: GET_MEASURE_GENERAL_WATCHER,
    payload,
  }
}

export function getMeasureGeneralSuccess(payload) {
  return {
    type: GET_MEASURE_GENERAL_SUCCESS,
    payload,
  }
}

export function getMeasureGeneralFailed(payload) {
  return {
    type: GET_MEASURE_GENERAL_FAILED,
    payload,
  }
}

export function getMeasureTotalWatcher(payload) {
  return {
    type: GET_MEASURE_TOTAL_WATCHER,
    payload,
  }
}

export function getMeasureTotalSuccess(payload) {
  return {
    type: GET_MEASURE_TOTAL_SUCCESS,
    payload,
  }
}

export function getMeasureTotalFailed() {
  return { type: GET_MEASURE_TOTAL_FAILED }
}

export function saveConfigBenchmarkWatcher(payload) {
  return {
    type: SAVE_CONFIG_BENCHMARK_WATCHER,
    payload,
  }
}

export function saveConfigBenchmarkSuccess(payload) {
  return {
    type: SAVE_CONFIG_BENCHMARK_SUCCESS,
    payload,
  }
}

export function saveConfigBenchmarkFailed() {
  return { type: SAVE_CONFIG_BENCHMARK_FAILED }
}
